import { Typography } from '@mui/material';
import type { ExternalJobImportPreview } from '../../../../types/externalJobImport.types';
import Button from '../../foundation/Button';
import CustomBR from '../../foundation/CustomBR';
import DialogWithHeader from '../../foundation/DialogWithHeader';
import { CapacityDialogActions } from './JobCapacityDialogs.styles';

type ExternalJobImportCapacityDialogProps = {
    preview: ExternalJobImportPreview
    isImporting: boolean
    onImportPartial: (amount: number) => void
    onBuyJobs: () => void
    onClose: () => void
};

export const ExternalJobImportCapacityDialog = ({
    preview,
    isImporting,
    onImportPartial,
    onBuyJobs,
    onClose,
}: ExternalJobImportCapacityDialogProps) => (
    <DialogWithHeader
        open
        onClose={onClose}
        title="אין מספיק משרות פנויות בבנק"
        maxWidth="sm"
        fullWidth>
        <>
            <Typography>
                נמצאו {preview.totalExternalJobs} משרות חיצוניות לייבוא.
            </Typography>
            <CustomBR />
            <Typography>
                בבנק שלך יש {preview.availableJobSlots} משרות פנויות,
                ולכן חסרות {preview.missingJobSlots} משרות כדי לייבא את כולן.
            </Typography>
            <CustomBR />
            <CapacityDialogActions>
                {preview.importableJobs > 0 && (
                    <Button
                        onClick={() => onImportPartial(preview.importableJobs)}
                        disabled={isImporting}>
                        {`ייבוא ${preview.importableJobs} מתוך ${preview.totalExternalJobs} משרות`}
                    </Button>
                )}
                <Button
                    onClick={onBuyJobs}
                    disabled={isImporting}
                    variant="outlined">
                    רכישת משרות
                </Button>
                <Button
                    onClick={onClose}
                    disabled={isImporting}
                    variant="text">
                    ביטול
                </Button>
            </CapacityDialogActions>
        </>
    </DialogWithHeader>
);
